// extracted by mini-css-extract-plugin
export default {"root":"SelectBoxedField_root__kNthK","form":"SelectBoxedField_form__GMYTt","textfield":"SelectBoxedField_textfield__TWZQB"};